if (!customElements.get("custom-video")) {
  customElements.define(
    "custom-video",
    class CustomVideo extends HTMLElement {
      constructor() {
        super();
        this.noInteract = this.hasAttribute("data-no-interact");
        this.isPlaying = false;
      }
      connectedCallback() {
        this.video = this.querySelector("video");
        if (!this.noInteract) {
          this.playButton = this.querySelector("[data-play-button]");
          this.video.addEventListener("loadedmetadata", () => {
            this.video.play();
            this.isPlaying = true;
          });
          this.video.addEventListener("click", () => {
            if (this.isPlaying) {
              this.video.pause();
              this.playButton.style.display = "block";
              this.isPlaying = false;
            } else {
              this.video.play();
              this.playButton.style.display = "none";
              this.isPlaying = true;
            }
          });
          this.playButton.addEventListener("click", () => {
            this.video.play();
            this.playButton.style.display = "none";
            this.isPlaying = true;
          });
        }
      }
    }
  );
}
